import { STRING, NUMBER, DATE } from 'shared/constants/InvoiceFiltersTypes';

export const STATUS = "status";
export const PERIOD = "period";
export const PAGE_SIZE = "pageSize";
export const FILTERS = "filters";

export const INITIAL_FILTERS_STATE = [
  {
    title: 'Invoice Number',
    collapsed: true,
    filterValidationError: '',
    data: {
      key: 'invoiceNumber',
      value: '',
      type: STRING
    }
  },
  {
    title: 'Start Date',
    collapsed: true,
    filterValidationError: '',
    data: {
      key: 'invoiceStartDate',
      value: '',
      type: DATE
    }
  },
  {
    title: 'End Date',
    collapsed: true,
    filterValidationError: 'The start date should be selected',
    disabled: true,
    data: {
      key: 'invoiceEndDate',
      value: '',
      type: DATE
    }
  },
  {
    title: 'Vendor',
    collapsed: true,
    filterValidationError: '',
    data: {
      key: 'vendorName',
      value: '',
      type: STRING
    }
  },
  {
    title: 'Gross Amount',
    collapsed: true,
    filterValidationError: '',
    data: {
      type: NUMBER,
      min: {
        key: 'grossAmountMin',
        value: ''
      },
      max: {
        key: 'grossAmountMax',
        value: ''
      }
    }
  },
  {
    title: 'Vendor Tax',
    collapsed: true,
    filterValidationError: '',
    data: {
      type: NUMBER,
      min: {
        key: 'vendorTaxMin',
        value: '',
        allowNegative: true
      },
      max: {
        key: 'vendorTaxMax',
        value: '',
        allowNegative: true
      }
    }
  },
  {
    title: 'Sovos Tax',
    collapsed: true,
    filterValidationError: '',
    data: {
      type: NUMBER,
      min: {
        key: 'sovosTaxMin',
        value: '',
        allowNegative: true
      },
      max: {
        key: 'sovosTaxMax',
        value: '',
        allowNegative: true
      }
    }
  },
  {
    title: '$ Variance',
    collapsed: true,
    filterValidationError: '',
    data: {
      type: NUMBER,
      min: {
        key: 'dollarVarianceMin',
        value: '',
        allowNegative: true
      },
      max: {
        key: 'dollarVarianceMax',
        value: '',
        allowNegative: true
      }
    }
  },
  {
    title: '% Variance',
    collapsed: true,
    filterValidationError: '',
    data: {
      type: NUMBER,
      min: {
        key: 'percentVarianceMin',
        value: '',
        allowNegative: true
      },
      max: {
        key: 'percentVarianceMax',
        value: '',
        allowNegative: true
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/shared/constants/InvoiceFiltersInitialState.js